/**
 * navigator.storage.persist() — asked once, right after the first mitosis
 * (the moment of emotional investment; grant odds are better with engagement).
 */
const ASKED_KEY = 'tg.persistAsked';

export function requestPersistOnce(): void {
  try {
    if (localStorage.getItem(ASKED_KEY) === '1') return;
    localStorage.setItem(ASKED_KEY, '1');
    void navigator.storage?.persist?.();
  } catch {
    // unsupported — nothing to do
  }
}
